import store from "@/store";
import { axiosSingleton } from "../plugins/axios";

export function getData(nue) {
  return Vue.http.get(`/uade/plananual/CargaAcademica/${nue}`);
}

function parseParams(params) {
  const keys = Object.keys(params);
  let options = "";

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === "object";
    const isParamTypeArray = isParamTypeObject && params[key].length >= 0;

    if (!isParamTypeObject) {
      options += `${key}=${params[key]}&`;
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
}

export function postDataExternoInformacionComplementaria(obj) {
  return axiosSingleton.getInstance()({
    method: "post",
    url: "/Externos/PostExternoInformacionComplementaria",
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getAccesoAdministrador() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Acceso/GetAccesoAdministrador",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getValidacionServicioExterno(idServicio, claveServicio) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/IntServicio/getValidacionServicioExterno/${idServicio}/${claveServicio}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getDataExternoCamposDatosServiciosByIdServicioRegistro(
  idServicio,
  idTipoPersona
) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/ExternoCamposDatosServicios/GetExternoCamposDatosServiciosByIdServicioRegistro/${idServicio}/${idTipoPersona}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getDataExternoDatosComplementariosByIdExtServReqPk(
  idExtServReqPk
) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/ExternoDatosComplementarios/GetDataExternoDatosComplementariosByIdExtServReqPk/${idExtServReqPk}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getInformacionBandejaAdministrador() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Administrador/GetInformacionBandejaAdministrador",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getSolicitudServicioPendientes() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/SolicitudServicio/GetSolicitudServicioPendientes",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getSolicitudServicioPendientesPaginated(options, search) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/SolicitudServicio/GetSolicitudServicioPendientesPaginated",
    params: {
      page: options.page,
      itemsPerPage: options.itemsPerPage,
      sortBy: options.sortBy[0] == undefined ? "" : options.sortBy[0],
      sortDesc: options.sortDesc[0] == undefined ? false : options.sortDesc[0],
      search: search,
    },
    paramsSerializer: (params) => parseParams(params),
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getInformacionBandejaExterno() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Externos/GetInformacionBandejaExterno",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getServiciosExterno() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Externos/GetServiciosExterno",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getServicio(idServicio) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/IntServicio/${idServicio}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getRequisitosServicio(idServicio, idTipoPersona) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/IntServicioRequisito/GetIntServicioRequisitoByIdServicio/${idServicio}/${idTipoPersona}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getRequisitosServicioAdministrador(idServicio, idExterno) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/IntServicioRequisito/GetIntServicioRequisitoAdministrador/${idServicio}/${idExterno}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getServiciosDisponiblesExterno() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Externos/GetServiciosDisponiblesExterno",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getTiposDocumentos() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/TipoDocumentoDigital",
  });
}

export function getDataDocumentoUsuarioByIdTipoDocumento(idTipoDocumento) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/ExternoDocumentos/GetExternoDocumentosUsuarioByIdTipoDocumento/${idTipoDocumento}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getDataDocumentoUsuarioByIdExtServReq(idExtServReqPk) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/ExternoDocumentos/GetExternoDocumentosUsuarioByIdExtServReq/${idExtServReqPk}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getDataDocumentoFile(idArchivo, uuid) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/ExternoDocumentos/getExternoDocumentosFile/${idArchivo}/${uuid}`,
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function postDataExternoServicioRequisitoObservaciones(
  idExtServReqPk,
  observaciones
) {
  var obj = {
    IdExtServReqPk: idExtServReqPk,
    IdServicioFk: 0,
    ObservacionRechazado: observaciones,
  };

  return axiosSingleton.getInstance()({
    method: "post",
    url: "/ExternoServicioRequisitos/PostExternoServicioRequisitoComentarios",
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function postDataExternoServicioRequisitoValidar(idExtServReqPk) {
  var obj = {
    IdExtServReqPk: idExtServReqPk,
    IdServicioFk: 0,
  };

  return axiosSingleton.getInstance()({
    method: "post",
    url: "/ExternoServicioRequisitos/PostExternoServicioRequisitoValidar",
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function postDataDocumento(obj, file) {
  var formData = new FormData();
  formData.append("archivo", file);
  formData.append("idTipoDocumento", obj.idTipoDocumento);

  return axiosSingleton.getInstance()({
    method: "post",
    url: "/ExternoDocumentos",
    data: formData,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getItemsList(url) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: url,
  });
}

export function postDataExternoDatosCamposServicios(
  idServicio,
  datos,
  idEstatus,
  idTipoPersona
) {
  return axiosSingleton.getInstance()({
    method: "post",
    url: `/ExternoCamposDatosServicios/PostExternoCamposDatosServiciosForm/${idServicio}/${idEstatus}/${idTipoPersona}`,
    data: datos,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getEstatusServicioDisponible(idServicio, claveServicio) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/IntServicio/GetEstatusServicioDisponible/${idServicio}/${claveServicio}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}
